<template>
    <div class="tab-content">
        <company-tags :company-list="companyList"></company-tags>
        <van-list
                v-if="(list && list.length) || loading"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
            <nearby-position v-for="item in list" :position="item"></nearby-position>
        </van-list>
        <no-data v-else></no-data>
    </div>
</template>

<script>
  
  import nearbyPosition from "./nearbyPosition";
  import companyTags from '@/components/companyTags'
  import {getAiCandidateDetail, getAiMatchScore, getAiTalentDetail} from '@/api/aiMatch'
  import {getListHomo} from '@/api/positions'
  import NoData from "@/components/noData";
  export default {
    components: { nearbyPosition , companyTags, NoData},
    props: {
      type:{
        type:Number,
        default:0
      }
    },
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        pageSize: 10,
        pageNo: 1,
        companyList: []
      }
    },
    methods: {
      onLoad() {
        this.loading = true;
        let params = [],
            getList = '';
        if(this.type == 1){
          params = {pageNo:this.pageNo, pageSize: this.pageSize, scene: 5, sourceId: this.$route.params.positionId, ...this.$route.query};
          getList = getListHomo;
        }else if(this.type == 2){
          params = {pageNo:this.pageNo, pageSize: this.pageSize, scene: 6, sourceId: this.$route.params.sourceId, ...this.$route.query};
          getList = getAiTalentDetail;
        }else{
          params = {pageNo:this.pageNo, pageSize: this.pageSize, aiRepeatedRecommend: false, sourceId: this.$route.params.sourceId, ...this.$route.query};
          getList = getAiCandidateDetail;
        }
        getList(params).then(res=>{
            if(res.data&&res.data.positionList){
              let ids = [];
              res.data.positionList.forEach(item=>{
                item.matchScore = 0;
                item.matchCounts = 0;
                item.unMatchCounts = 0;
                ids.push(item.positionId);
              })

              this.list = this.list.concat(res.data.positionList||[]);
              this.pageNo++;
              if(res.data.positionList.length<this.pageSize)
                this.finished = true;

              if(ids.length){
                this.getMatchScore(ids);
              }
            }else{
              this.finished = true;
            }
            if(res.data&&res.data.enterpriseList){
              this.companyList = res.data.enterpriseList || [];
            }
          }).catch(err=>{}).finally(()=>{this.loading = false;})
      },
      getMatchScore(ids){
        let query = {ids: ids.join(',')};
        if(this.type == 1){
          query.type= 0;
          query.id= this.$route.params.positionId;
        }else if(this.type == 2){
          query.type = 1;
          query.id= this.$route.params.sourceId;
        }else if(this.type == 3){
          query.type= 2;
          query.id = this.$route.params.sourceId;
        }else{
          query.type= 3;
          query.id = this.$route.params.sourceId;
        }
        getAiMatchScore({...query}).then(res=>{
          if(res.data){
            for(let id in res.data){
              let aiArr = [];
              let item = res.data[id];
              item.mustmust.forEach(e=>{
                if(e.cityScore || e.functionScore || e.ageScore || e.workYearsScore || e.cityScore == false || e.functionScore == false || e.ageScore == false || e.workYearsScore == false){
                  aiArr.push(e);
                }
              })
              item.precedence.forEach(e=>{
                if(e.degreeScore >= 0 || e.salaryScore >= 0 || e.skillScore >= 0 || e.fieldScore >= 0 || e.companyFactionScore >= 0){
                  aiArr.push(e);
                }
              })
              aiArr.forEach(e=>{
                if(e.cityScore || e.functionScore || e.ageScore || e.workYearsScore || e.degreeScore >= 0.544 || e.salaryScore >= 0.544 || e.skillScore >= 0.544 || e.fieldScore >= 0.544 || e.companyFactionScore >= 0.544){
                  item.matchCounts = (item.matchCounts||0) + 1;
                }else if(!e.sourceSalary || (e.sourceSalary && e.sourceSalaryName && e.salaryScore < 0.544)){
                  item.unMatchCounts = (item.unMatchCounts||0) + 1;
                }
              })
            }

            this.list.forEach(item=>{
              if(res.data[item.positionId]){
                item.matchScore = res.data[item.positionId].matchScore
                item.matchCounts = res.data[item.positionId].matchCounts;
                item.unMatchCounts = res.data[item.positionId].unMatchCounts;
              }
            })
          }
        }).catch(err=>{})
      }
    },
    watch: {
      $route(n,o){
        this.list = [];
        this.pageNo = 1;
        this.finished = false;
        this.onLoad();
      }
    },
    created() {
      this.onLoad();
    }
  };
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.tab-content{
    background-color: #f5f5f5;
    padding: 0!important;
    .company-wrap{
        padding: 10px 15px;
        background-color: #fff;
        .company-box::-webkit-scrollbar{
            display: none;
        }
        .company-box{
            display: flex;
            overflow-y: hidden;
            width: 100%;
            overflow-x: scroll;
            .company-tag{
                background-color: #f5f5f5;
                border-radius: 4px;
                line-height: 30px;
                color: #666;
                padding: 0 10px;
                white-space: nowrap;
                margin-right: 10px;
            }
        }
    }
}
</style>
